const gymName = [
    "동작구민체육센터",
    "사당문화회관",
    "사당종합체육관",
    "삼일수영장",
    "상도스포츠클럽",
    "흑석체육센터",
]

const gymNum = {
    "동작구민체육센터":"0",
    "사당문화회관":"1",
    "사당종합체육관":"2",
    "삼일수영장":"3",
    "상도스포츠클럽": "4",
    "흑석체육센터":"5",
}

module.exports = {gymNum, gymName}